export interface IListMedicationsEndpointQuery {
  medication_route_id?: string;
  title?: string;
}

export interface IListMedicationsEndpointResponse {
  list: {
    id: string;
    is_favorite: boolean;
    title: string;
  }[];
}

export const listMedicationsEndpoint = () => '/medications';
